import { object, string, bool, ref, number } from 'yup';

export default object().shape({
    UserType:
        string()
            .required('REQUIRED'),
    Extension:
        number()
            .required('REQUIRED'),
    Edition: bool(),
    ExtensionPassword:
        string()
            .when('Edition', {
                is: true,
                then:
                    string()
                        .test({
                            name: 'PasswordValidator',
                            exclusive: true,
                            message: 'VALID_PASSWORD',
                            test: value => {
                                if (value) {
                                    const passwordValidator = new RegExp(/^(?=.*[A-Z])(?=.*[!#$&*@])(?=.*\d)(?=.*[a-z]).{8,20}/);

                                    return passwordValidator.test(value);
                                }

                                return true;
                            }
                        }),
                otherwise:
                    string()
                        .required('REQUIRED')
                        .matches(/^(?=.*[A-Z])(?=.*[!#$&*@])(?=.*\d)(?=.*[a-z]).{8,20}/, 'VALID_PASSWORD')
            }),
    RepeatedPassword:
        string()
            .when(['Edition', 'ExtensionPassword'], {
                is: (edition, extensionPassword) => (edition && extensionPassword) || !edition,
                then:
                    string()
                        .required('REQUIRED')
                        .oneOf([ref('ExtensionPassword')], 'MATCH_PASSWORD'),
            }),
    Profiles:
        string()
            .required('REQUIRED'),
    UseSecurityPin:
        bool(),
    SecurityPin:
        number()
            .when('UseSecurityPin', {
                is: true,
                then:
                    number()
                        .typeError('only_numbers')
                        .required('REQUIRED'),
                otherwise:
                    number()
                        .typeError('only_numbers')
            })
});
